<template>
  <div v-if="isS365">
    <div style="z-index: 2; position: fixed; top: 0; background-color: #FFFFFF;">
      <div :style="{ height: paddingTop + 'px' }"></div>
      <div class="bar" >
        <img class="img" :style="{ top: 10 + paddingTop + 'px' }" src="../assets/back.png" alt="" style="width: 24px; height: 24px;" @click="goBack">
        <span>{{ title }}</span>
      </div>
    </div>
    <div class="my-div" :style="{ height: 44  + paddingTop + 'px' }"></div>
<!--    <van-button type="small" @click="doGetSafe">输出数据</van-button>-->
<!--    <van-button type="small" @click="doGetUserAgent">输出UserAgent</van-button>-->
<!--    <van-button type="small" @click="doGetHeight">输出Height</van-button>-->
  </div>
</template>

<script>
import Vue from 'vue'
import { S365Util } from '@/utils/s365Util'
import app from '@/utils/s365Api.js'

import { Button, Toast } from 'vant'
Vue.use(Button)
export default {
  props: {
    myTitle: {
      default: ''
    }
  },
  data() {
    return {
      paddingTop: 0,
      isS365: false
    }
  },
  computed: {
    title() {
      if (this.myTitle !== '') return this.myTitle
      return this.$route.meta.title || ''
    }
  },
  mounted() {
    this.isS365 = S365Util.isInApp()
    if (S365Util.isInIosApp()) {
      this.paddingTop = parseInt(app.getSafeAreaTop())
    }
  },
  methods: {
    doGetSafe() {
      Toast('刘海高度为：' + this.paddingTop)
    },
    doGetUserAgent() {
      Toast('UserAgent：' + window.navigator.userAgent)
    },
    doGetHeight() {
      const my = document.querySelector('.my-div')
      Toast(my.clientHeight)
    },
    goBack() {
      if (this.isS365 && this.$route.meta.title === '赛事广场') {
        app.closeWebView()
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 100vw;
  //box-shadow: 0px 0px 6px 0px rgba(0,0,0,.06);
  .img {
    position: absolute;
    top: 10px;
    left: 12px;
  }
}
</style>
